// What new users pick on /workspace ("What will you use Bumpups for?"), and what each choice
// recommends: the upload wording, ready-made examples (ids in examples.js) and the first chat
// questions suggested on every video.
import {
  faGraduationCap, faChalkboardUser, faFutbol, faPodcast, faBriefcase, faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';

export const USE_CASES = [
  {
    id: 'study',
    label: 'Studying & lectures',
    short: 'Studying',
    icon: faGraduationCap,
    upload: 'Upload a lecture recording',
    examples: ['neural-networks', 'schools-creativity', 'stanford-commencement'],
    suggestions: ['Make a study guide with timestamps', 'Quiz me with 5 questions', 'Explain the hardest part simply', 'Summarize the video'],
  },
  {
    id: 'teach',
    label: 'Teaching',
    short: 'Teaching',
    icon: faChalkboardUser,
    upload: 'Upload a lesson recording',
    examples: ['classroom-lesson', 'schools-creativity', 'neural-networks'],
    suggestions: [
      'Find the moments where the teacher checks for understanding',
      'List the teaching strategies used, with timestamps',
      'What would make this lesson stronger?',
      'Summarize the lesson',
    ],
  },
  {
    id: 'coach',
    label: 'Coaching & sports',
    short: 'Coaching',
    icon: faFutbol,
    upload: 'Upload game film or practice video',
    examples: ['build-up-play', 'game-model', 'procrastination'],
    suggestions: [
      'Break down the key tactical ideas with timestamps',
      'Turn this into a training session plan',
      'What should players focus on?',
      'Summarize the video',
    ],
  },
  {
    id: 'create',
    label: 'YouTube & podcasts',
    short: 'Creators',
    icon: faPodcast,
    upload: 'Upload your episode or video',
    examples: ['procrastination', 'stanford-commencement', 'start-with-why'],
    suggestions: [
      'Write a YouTube description with chapters',
      'Pull 5 quotable moments with timestamps',
      'Write show notes',
      'Suggest 3 short clips to cut',
    ],
  },
  {
    id: 'work',
    label: 'Meetings & interviews',
    short: 'Meetings',
    icon: faBriefcase,
    upload: 'Upload a meeting or interview recording',
    examples: ['team-meeting', 'job-interview', 'start-with-why'],
    suggestions: [
      'List the decisions and action items',
      'Summarize this for someone who missed it',
      'What questions came up, and how were they answered?',
      'Draft a follow-up email',
    ],
  },
  {
    id: 'other',
    label: 'Something else',
    short: 'Other',
    icon: faWandMagicSparkles,
    upload: 'Upload any video',
    examples: ['procrastination', 'neural-networks', 'start-with-why'],
    suggestions: ['Summarize the video', 'What are the key takeaways?', 'Write show notes with timestamps', 'Quiz me with 5 questions'],
  },
];

export const DEFAULT_SUGGESTIONS = USE_CASES.find(u => u.id === 'other').suggestions;

export const findUseCase = id => USE_CASES.find(u => u.id === id) || null;

// The questions to suggest on a video: an example's own, else the user's use case, else the defaults
export function suggestionsFor(useCaseId, exampleUseCase) {
  return (findUseCase(exampleUseCase) || findUseCase(useCaseId))?.suggestions || DEFAULT_SUGGESTIONS;
}
